export default "__VITE_ASSET__dyqPXH6K__"